export enum CurrencyIso {
    USD = 'USD',
    SGD = 'SGD',
    MYR = 'MYR',
    PHP = 'PHP',
    EUR = 'EUR',
    JPY = 'JPY',
    GBP = 'GBP',
    CAD = 'CAD',
    AUD = 'AUD',
    NZD = 'NZD',
    ZAR = 'ZAR',
    PKR = 'PKR',
    INR = 'INR',
    CHF = 'CHF',
}

export type Currency = {
    iso: CurrencyIso
    conversion_rate: number
    symbol: string
}

export const CURRENCIES = [
    {
        iso: CurrencyIso.USD,
        conversion_rate: 1,
        symbol: '$',
    },
    {
        iso: CurrencyIso.SGD,
        conversion_rate: 1.37,
        symbol: '$',
    },
    {
        iso: CurrencyIso.MYR,
        conversion_rate: 2101.05,
        symbol: 'RM',
    },
    {
        iso: CurrencyIso.PHP,
        conversion_rate: 57.21,
        symbol: '₱',
    },
    {
        iso: CurrencyIso.EUR,
        conversion_rate: 0.97,
        symbol: '€',
    },
    {
        iso: CurrencyIso.JPY,
        conversion_rate: 140.17,
        symbol: '¥',
    },
    {
        iso: CurrencyIso.GBP,
        conversion_rate: 0.85,
        symbol: '£',
    },
    {
        iso: CurrencyIso.AUD,
        conversion_rate: 1.49,
        symbol: '$',
    },
    {
        iso: CurrencyIso.NZD,
        conversion_rate: 1.64,
        symbol: '$',
    },
    {
        iso: CurrencyIso.ZAR,
        conversion_rate: 17.26,
        symbol: 'R',
    },
    {
        iso: CurrencyIso.PKR,
        conversion_rate: 221.74,
        symbol: 'Rs',
    },
    {
        iso: CurrencyIso.INR,
        conversion_rate: 81.16,
        symbol: '₹',
    },
    {
        iso: CurrencyIso.CHF,
        conversion_rate: 0.94,
        symbol: 'CHF',
    },
    {
        iso: CurrencyIso.CAD,
        conversion_rate: 1.33,
        symbol: '$',
    },
]

export function getPriceFromContent(
    translate_key: string,
    translations: Record<string, string>
) {
    let price = translations[translate_key]

    if (price == undefined) {
        price = '0'
    } else {
        price = price.match(new RegExp(/\d+/)) + ''
    }

    return parseInt(price, 10)
}

export function getTotalPrice(
    price: number,
    conversion_rate: number,
    discount?: number
) {
    return Math.round(price * conversion_rate)
}
